import { clearSysMessage } from "@/redux/slice/api";
import { useAppDispatch, useAppSelector } from "@redux/store";
import { message } from "antd";
import { useEffect } from "react";

function GlobalMessage() {
  const [messageApi, contextHolder] = message.useMessage();
  const api = useAppSelector(state => state.api);
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (api.message?.content) {
      messageApi.open({
        type: api.message.type,
        content: api.message.content,
        duration: 2,
      });
      dispatch(clearSysMessage());
    }
  }, [api.message?.content]);

  return contextHolder;
}

export default GlobalMessage;
